export default "__VITE_ASSET__ee2a7334__"